"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConnectionTestState = /** @class */ (function () {
    function ConnectionTestState() {
        this.connectionSuccesful = false;
        this.errorMessage = undefined;
    }
    return ConnectionTestState;
}());
exports.ConnectionTestState = ConnectionTestState;
//# sourceMappingURL=connectionTestState.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/model/connectionTestState.js
 ** module id = 2079
 ** module chunks = 0
 **/